import { render, staticRenderFns } from "./Toc.vue?vue&type=template&id=285eb096&scoped=true"
import script from "./Toc.vue?vue&type=script&lang=js"
export * from "./Toc.vue?vue&type=script&lang=js"
import style0 from "./Toc.vue?vue&type=style&index=0&id=285eb096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285eb096",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TocList: require('/workspace/components/TocList.vue').default})
